// extracted by mini-css-extract-plugin
export default {"PageListeDemandes":"PageListeDemandes_PageListeDemandes__WR0bs","AucuneDemande":"PageListeDemandes_AucuneDemande__aCKj4"};